import LandingSelector from './LandingSelector';

export const ConfirmAdmission = {
  name: 'สอบติดแล้ว!!',
  location: '/confirmTCAS',
  component: LandingSelector,
};

export default ConfirmAdmission;
